var map = {
	"./icons/papsi_branches.svg": 4721,
	"./icons/papsi_company.svg": 823,
	"./icons/papsi_election.svg": 9757,
	"./icons/papsi_error_icon.svg": 1086,
	"./icons/papsi_help.svg": 4976,
	"./icons/papsi_home.svg": 590,
	"./icons/papsi_location_icon.svg": 5765,
	"./icons/papsi_logout_icon.svg": 7037,
	"./icons/papsi_profile.svg": 5863,
	"./icons/papsi_success_icon.svg": 2164,
	"./icons/papsi_warning.svg": 6484,
	"./icons/qr.svg": 4301,
	"./icons/search_user.svg": 7543,
	"./images/Facebook_f_logo.png": 4097,
	"./images/Instagram_logo.png": 3071,
	"./images/alert/papsi_error_icon.svg": 9983,
	"./images/alert/papsi_info_icon.svg": 6471,
	"./images/alert/papsi_success_icon.svg": 3240,
	"./images/alert/papsi_warning_icon.svg": 2170,
	"./images/loader/papsi_loading_icon.gif": 8909,
	"./images/papsi_about_icon.svg": 3970,
	"./images/papsi_account_icon.svg": 8769,
	"./images/papsi_arrow_icon.svg": 9647,
	"./images/papsi_avatar_icon.svg": 6834,
	"./images/papsi_back_icon.svg": 3599,
	"./images/papsi_check_icon.svg": 1658,
	"./images/papsi_ck_off_icon.svg": 8153,
	"./images/papsi_ck_on_icon.svg": 5416,
	"./images/papsi_dashboard_icon.svg": 4822,
	"./images/papsi_delete_icon.svg": 2030,
	"./images/papsi_edit_icon.svg": 1065,
	"./images/papsi_election_icon.svg": 9610,
	"./images/papsi_error_icon.svg": 536,
	"./images/papsi_forgot_password_icon.svg": 8199,
	"./images/papsi_help.svg": 2066,
	"./images/papsi_info_icon.svg": 2119,
	"./images/papsi_information_icon.svg": 7075,
	"./images/papsi_invi_icon.svg": 9003,
	"./images/papsi_list_icon.svg": 8513,
	"./images/papsi_lock_icon.svg": 6002,
	"./images/papsi_login_icon.svg": 7734,
	"./images/papsi_logo_nav_icon.png": 898,
	"./images/papsi_logout_icon.svg": 2020,
	"./images/papsi_menu_icon.svg": 1298,
	"./images/papsi_otp_icon.svg": 806,
	"./images/papsi_otpin_icon.svg": 124,
	"./images/papsi_password_icon.svg": 7046,
	"./images/papsi_password_primary_icon.svg": 9366,
	"./images/papsi_pencil_icon.svg": 6984,
	"./images/papsi_phone.svg": 9639,
	"./images/papsi_registration_icon.svg": 6696,
	"./images/papsi_selected_adcom.svg": 4732,
	"./images/papsi_selected_elecom.svg": 4121,
	"./images/papsi_selected_icon.svg": 5975,
	"./images/papsi_settings_icon.svg": 4144,
	"./images/papsi_signature_icon.svg": 4714,
	"./images/papsi_social_media.svg": 4906,
	"./images/papsi_star_off_icon.svg": 5017,
	"./images/papsi_star_on_icon.svg": 4046,
	"./images/papsi_success_icon.svg": 1048,
	"./images/papsi_up_icon.svg": 8402,
	"./images/papsi_vis_icon.svg": 7000,
	"./images/question_mark_icon.svg": 8565,
	"./images/signature.jpg": 615,
	"./tailwind.css": 1356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;